import { connect } from 'react-redux';
import Badge from '../../badge';
import classes from './classes.module.scss';

const mapStateToProps = ({ application }) => ({
  count: application.badgeCount,
  customClass: classes.badgeContainer
});

export default connect(mapStateToProps)(Badge);
